export default "__VITE_ASSET__Bm_S7_fF__"